import { motion } from "framer-motion";

type ComicPanelProps = {
	children: React.ReactNode;
	delay?: number;
	className?: string;
};

const ComicPanel = ({ children, delay = 0, className = "" }: ComicPanelProps) => {
	return (
		<motion.div
			initial={{ opacity: 0, y: 20 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ delay, duration: 0.5 }}
			className={`relative bg-black/30 backdrop-blur-sm rounded-xl p-6 lg:p-8 border-4 border-white/20 hover:border-white/30 transition-colors ${className}`}>
			{/* Comic Book Style Corner */}
			<div className='absolute -top-2 -right-2 w-8 h-8 bg-trump-yellow transform rotate-12 rounded-sm shadow-lg' />
			<div className='absolute -bottom-2 -left-2 w-6 h-6 bg-trump-red transform -rotate-12 rounded-sm shadow-lg' />
			{children}
		</motion.div>
	);
};

export default ComicPanel;
